import type { UserInfo } from '../../types/UserInfo';
import { useInviteFriendData } from './useInviteFriendData';
import { usePersonalBeautyStoreData } from './usePersonalBeautyStoreData';

export const usePersonalBeautyStoreUserInfo = (): UserInfo => {
  const pbsData = usePersonalBeautyStoreData();
  const inviteFriendData = useInviteFriendData();

  if (pbsData) {
    const { firstName, lastName, photoUrl } = pbsData.beautyStore?.profile ?? {};

    return { firstName: firstName ?? null, lastName: lastName ?? null, photoUrl: photoUrl ?? null };
  }

  if (inviteFriendData) {
    const { firstName, lastName, photoUrl } = inviteFriendData.inviteFriendProfile ?? {};

    return { firstName: firstName ?? null, lastName: lastName ?? null, photoUrl: photoUrl ?? null };
  }

  return {
    firstName: null,
    lastName: null,
    photoUrl: null,
  };
};
